"use client";

import { WhatsAppIcon } from "@/components/dashboard/socials-dropup";
import { motion, AnimatePresence } from "framer-motion";
import Image from "next/image";
import { X } from "lucide-react";
import { useState } from "react";

export const WhatsAppWidget = () => {
    const [isVisible, setIsVisible] = useState(true);

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ opacity: 0, scale: 0.8, x: 100 }}
                    animate={{ 
                        opacity: 1, 
                        scale: 1, 
                        x: [100, -10, 0], // Pop up from bottom
                    }}
                    exit={{ 
                        opacity: 0, 
                        scale: 0.8, 
                        x: 100, 
                        transition: { duration: 0.4, ease: "easeInOut" } 
                    }}
                    transition={{
                        duration: 0.8,
                        ease: "easeOut",
                    }}
                    className="fixed bottom-40 right-3 z-[60] flex flex-col items-center transition-all"
                >
                    {/* Close Button */}
                    <button 
                        onClick={() => setIsVisible(false)}
                        className="absolute cursor-pointer top-5 left-4 z-20 w-4 h-4 rounded-full bg-slate-700 backdrop-blur-xl border border-white/20 flex items-center justify-center text-slate-50 hover:text-white transition-all hover:bg-slate-900 group pointer-events-auto"
                        aria-label="Close"
                    >
                        <X size={10} strokeWidth={3} />
                    </button>

                    <div className="relative w-22 h-22 -mb-4 z-10 pointer-events-none">
                        <Image
                            src="https://seedicon-dev-public-images.s3.ap-south-1.amazonaws.com/1776345993562_r106qfbkma_Gemini_Generated_Image_llm6b5llm6b5llm6-removebg-preview.png"
                            alt="WhatsApp Community"
                            fill
                            className="object-contain drop-shadow-2xl"
                        />
                    </div>
                    
                    <div className="flex flex-col items-center text-center pointer-events-auto group ">
                        <div className="flex items-center gap-2 mb-0.5">
                            <span className="text-[14px] font-bold text-slate-800 leading-tight block">
                                Join Community
                            </span>
                        </div>
                        <span className="text-[11px] font-medium text-slate-600 mb-3 leading-tight opacity-70">
                            Get early access
                        </span>
                        <a
                            href="https://chat.whatsapp.com/B9gMJ4FvMNHGIgKQMux1zq"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-emerald-500 hover:bg-emerald-600 text-white text-[11px] font-extrabold px-5 py-2 rounded-full transition-all shadow-lg shadow-emerald-500/30 active:scale-95 whitespace-nowrap"
                        >
                            <span className="flex items-center gap-2"><WhatsAppIcon className="w-4 h-4 text-white"/>JOIN NOW</span>
                        </a>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
